export class Redirections {
    id: any;
    clipboard = !0;
    printer = !0;
    rememberCollection = !1;
}
